// authInitialState.js
const loadAuthFromStorage = () => {
  try {
    const userInfoStr = localStorage.getItem('userInfo');
    const userRole = localStorage.getItem('userRole');

    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr);
      return {
        isLoggedIn: false, // ⬅️ never trust this until session is verified
        authData: {
          email: userInfo.email,
          id: userInfo.id || userInfo.sub,
          name: userInfo.name,
          photo: userInfo.photo || userInfo.picture,
          role: (userRole || userInfo.role || 'student').toLowerCase()
        }
      };
    }
  } catch (err) {
    console.error('❌ Failed to load auth from storage:', err);
  }

  return {
    isLoggedIn: false,
    authData: {}
  };
};

export default loadAuthFromStorage();